import { TugEngagedData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const TUG_ENGAGED_DATA_TAG = 'TugEngagedData';
export default class TugEngagedParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.TUG_ENGAGED, FIXED_PROTOCOL_CONTENT_TYPE_IDS.TUG_ENGAGED, TUG_ENGAGED_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            name: 'name',
            posGen: 'positionGeneral',
            posDet: 'positionDetailed',
            pulSec: 'pullingSecured',
            oAct: 'otherActivities',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new TugEngagedData(props.name || '', props.positionGeneral, props.positionDetailed, props.pullingSecured, props.otherActivities, props.freeText);
    }
}
//# sourceMappingURL=TugEngagedParser.js.map